import '~/assets/scss/profile.scss'

window.addEventListener('DOMContentLoaded', () => {
  /*
  let changePasswordButton = document.querySelector('#change-password-button'),
    changePasswordArea = document.querySelector('#change-password-area');

  function passwordInputHandler(area, value) {
    let passwordInputs = area.querySelectorAll('input[type=password]');
    if (passwordInputs.length) {
      passwordInputs.forEach(function(input) {
        if (value === 0) {
          input.removeAttribute('disabled');
        } else if (value === 1) {
          input.setAttribute('disabled', true);
        }
      });
    }
  }

  if (changePasswordButton) {
    changePasswordButton.addEventListener('click', function() {
      if (changePasswordArea.classList.contains('hidden')) {
        this.innerText = 'Отмена';
        changePasswordArea.classList.remove('hidden');
        passwordInputHandler(changePasswordArea, 0);
      } else {
        this.innerText = 'Изменить';
        changePasswordArea.classList.add('hidden');
        passwordInputHandler(changePasswordArea, 1);
        changePasswordArea.closest('form').reset();
      }
    });
  }
*/

});
